import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
    selector: 'app-wizard',
    templateUrl: './wizard.component.html',
    styleUrls: ['./wizard.component.scss'],
    animations: [
        trigger('step', [
            state('disabled', style({
                backgroundPosition: '100% 50%'
            })),
            state('visited', style({
                backgroundPosition: '0% 50%'
            })),
            state('active', style({
                backgroundPosition: '40% 50%'
            })),
            transition('disabled => active', [animate('300ms')]),
            transition('active => disabled', [animate('300ms')]),
            transition('active => visited', [animate('300ms')]),
            transition('visited => active', [animate('300ms {{delay}}ms')]),
            transition('visited => disabled', [animate('300ms {{delay}}ms')])
        ])
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WizardComponent {
    @Input() public set activeStep(step: number) {
        this.previousStep = this.activeStep;
        this._step = step;
    }

    public get activeStep(): number {
        return this._step;
    }

    @Input() public stepTitles: string[];
    @Input() public disabled: boolean;
    @Output() public changed = new EventEmitter<number>();

    public previousStep: number;

    private _step: number;

    constructor() {}

    public setStep(step: number): void {
        setTimeout(() => (this.activeStep = step));
    }

    public changeStep(step: number): void {
        if (this.disabled || step === this.activeStep || step > this.activeStep) {
            return;
        }

        this.setStep(step);
        this.changed.emit(step);
    }

    public delayAnimation(step: number) {
        // for active step
        if (step === this.activeStep && this.previousStep > this.activeStep) {
            return `delay-${this.previousStep - (step + 1)}`;
        }

        // for disabled steps
        return this.activeStep < step && this.previousStep > step ? `delay-${step}` : '';
    }
}
